<div  class="loginPageBackground">
  <div class="content-container padding-left-md padding-right-md">
    <img  class="logo" src="/assets/images/fleetoperate-logo.png" width="300px" />

    <div class="padding-top-sm center" >
      <h2 class="centerBoldedText">{{ title }}</h2>
      <span class="centerText">{{ errorMessage || '' }}<br />
        @if (!isBerbixConflict) {
          <a href="mailto:support@fleetoperate.com">support&#64;fleetoperate.com</a>
        }</span>
      </div>

      <div  class="padding-top-lg">
        @if (isBerbixConflict) {
          <div class="btn-desc">{{ btnDescription }}</div>
        }
        <button class="margin-bottom margin-top-xlg ok-button" mat-raised-button color="primary" type="submit"
          (click)="onNavigateToSignIn()">
          OK
        </button>
      </div>
    </div>

    <div class="footer">
      <span>Powered by</span>
      <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
    </div>
  </div>